module.exports = __webpack_public_path__ + "files/8b548f420416b032c4ec0de4ed13fb71.png";